import React from "react";
import {TextToolTip} from "../../components";


export const MainDetails = ({info, AnotherBlock}) => {
    return (
        <div className='main-details-block'>
            <div className="flex-gap-16">
                {info?.map(
                    (item, index) =>
                        !!item?.list?.length && (
                            <div className="main-details-wrapper" key={index}>
                                {!!item?.list?.length &&
                                    item?.list?.map((subList, index) => (
                                        <div className="main-details-box" key={index}>
                                            {subList?.title && (
                                                <h3 className="main-details-title">{subList?.title}</h3>
                                            )}

                                            <div className="main-details-items-wrapper">
                                                {!!subList?.list?.length &&
                                                    subList?.list?.map((listItem, index) => (
                                                        <div
                                                            className="main-details-items-box"
                                                            key={index}
                                                            style={{
                                                                width: listItem?.width ? listItem?.width : '',
                                                            }}
                                                        >
                                                            {listItem?.title && (
                                                                <p className="main-details-items-title">
                                                                    {listItem?.title}:
                                                                </p>
                                                            )}

                                                            <TextToolTip
                                                                classNameText="main-details-items-desc"
                                                                text={listItem?.desc}
                                                                content={listItem?.desc}
                                                                dateRow={listItem?.dateRow}
                                                                phoneRow={listItem?.phoneRow}
                                                                priceRow={listItem?.priceRow}
                                                            />
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        ),
                )}
            </div>
            {AnotherBlock ? AnotherBlock : ''}
        </div>
    );
};
